import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { AreaDto } from '../../../shared/modules/settings/dtos/area.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { LocationStatusEnum } from '../enums/location-status.enum';
import { LocationTypeEnum } from '../enums/location-type.enum';

/**
 * Location DTO
 */
@CaslSubject(AppSubjectEnum.LOCATION)
export class LocationListDto extends BaseDto {
  code!: string;
  name!: string;
  status!: LocationStatusEnum;
  type!: LocationTypeEnum;
  contact!: TenantContactDto;
  area!: AreaDto;
  tags?: TagListDto[] | null;
}
